import { language } from "../stores/storages/LanguageStorage";
import { profile } from "../stores/storages/ProfileStorage"
import { clientInfo } from "../version";
import api from "./api";
import config from "./config"
import formatter from './formatter'

const Settings = {
  getConfigApp: async () => {
    const { token, username: msisdn } = profile
    const timestamp = new Date().getTime();
    const security = formatter.encrypt(`${msisdn}desktop${token}${timestamp}`)

    const data = new FormData()
    data.append('user', msisdn)
    data.append('resource', 'desktop')
    data.append('timestamp', timestamp)
    data.append('security', security)

    const options = {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      decrypt: true,
    }

    return await api.request({
      method: config.endpoints.config.getConfigApp.method,
      path: config.endpoints.config.getConfigApp.path,
      host: config.host,
      data,
      options,
    })
  },
  setConfigApp: async (objConfig) => {
    const { token, username: msisdn } = profile
    const timestamp = new Date().getTime();
    const security = formatter.encrypt(`${msisdn}desktop${token}${timestamp}`)

    const data = new FormData()
    data.append('user', msisdn)
    data.append('data', JSON.stringify(objConfig))
    data.append('resource', 'desktop')
    data.append('timestamp', timestamp)
    data.append('security', security)

    const options = {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      decrypt: false,
    }

    const res = await api.request({
      method: config.endpoints.config.setConfigApp.method,
      path: config.endpoints.config.setConfigApp.path,
      host: config.host,
      data,
      options,
    })
    return res
  },
  getConfigV22: async () => {
    const { token, username: msisdn } = profile;
    const lang = language.language;
    const timestamp = new Date().getTime();
    const { country } = clientInfo;
    const clientType = 3;
    const security = formatter.encrypt(`${msisdn}${clientType}${lang}${country}${token}${timestamp}`);
    const data = {
      params: {
        msisdn,
        language: lang,
        clientType,
        country,
        timestamp,
        security,
      },
    };
    return await api.request({
      method: config.endpoints.config.getConfig.method,
      path: config.endpoints.config.getConfig.path,
      host: config.host,
      data: data,
      options: { decrypt: true },
    })
  }

}

export default Settings;